import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Redo } from '@bibliocommons/base-icons';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import './RefreshTable.scss';

export default class RefreshTable extends BcReactComponent {

  render() {
    const { handleRefresh, home } = this.props;
    return (
      <div className="updated-fines-page">
        <Link to={home} onClick={handleRefresh} id="updated_fines_page">
          <Redo className="small" /> <FormattedMessage id="fines_refresh_totals" />
        </Link>
      </div>

    );
  }
}

RefreshTable.propTypes = {
  handleRefresh: PropTypes.func,
  home: PropTypes.string
};




// WEBPACK FOOTER //
// ./app/components/borrowing/fines/RefreshTable/RefreshTable.jsx